import React, { useCallback, useEffect, useState, useMemo } from 'react'
import { getUserDahsa } from './charaDashaService'
import { Box, FormControl, Select, MenuItem, InputLabel, Button } from '@mui/material'
import { currentYear } from '../../shared'
import DashaSkeletonRow from './DashaSkeletonRow'

// import DashaView from './DashaView'
import DashaView from './DashaView'

const CharaDasha = ({ userId, user, padithi }) => {

    const [startYear, setStartYear] = useState(currentYear);
    const [endYear, setEndYear] = useState(currentYear + 1);

    const [dashaData, setDashaData] = useState([])
    const [dashaLoading, setDashaLoading] = useState(false)

    // Generate next 15 years list
    const availableYears = useMemo(() => {
        return Array.from({ length: 16 }, (_, i) => currentYear + i);
    }, []);

    const fetchUserDasha = useCallback(async () => {
        try {
            setDashaLoading(true)
            const response = await getUserDahsa({
                userId,
                userCurrentTimezone: user?.userCurrentTimezone,
                startYear,
                endYear
            });
            setDashaData(response.data)
        } catch (error) {
            console.log("Error fetching user's dasha");
        }finally {
            setDashaLoading(false)
        }
    }, [userId, padithi, startYear, endYear, user?.userCurrentTimezone]);


    // 🔥 Ensure end year is always greater than start year
    useEffect(() => {
        if (endYear <= startYear) {
            setEndYear(startYear + 1);
        }
    }, [startYear]);

    return (
        <Box >
            <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                <Box display="flex" gap={2}>
                    {/* Start Year */}
                    <FormControl sx={{ minWidth: 240 }}>
                        <InputLabel>Start Year</InputLabel>
                        <Select
                            label="Start Year"
                            value={startYear}
                            onChange={(e) => setStartYear(e.target.value)}
                        >
                            {availableYears.map((year) => (
                                <MenuItem key={year} value={year}>
                                    {year}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    {/* End Year */}
                    <FormControl sx={{ minWidth: 240 }}>
                        <InputLabel>End Year</InputLabel>
                        <Select
                            label="End Year"
                            value={endYear}
                            onChange={(e) => {
                                const selected = e.target.value;
                                if (selected > startYear) setEndYear(selected);
                            }}
                        >
                            {availableYears
                                .filter((y) => y > startYear)
                                .map((year) => (
                                    <MenuItem key={year} value={year}>
                                        {year}
                                    </MenuItem>
                                ))}
                        </Select>

                    </FormControl>
                </Box>

                <Button
                    type="button"
                    variant="contained"
                    className='mt-2'
                    disabled={dashaLoading}
                    sx={{ py: 1.5, width: 200 }}
                    onClick={fetchUserDasha}
                >
                    View Chara Dasha
                </Button>
            </Box>
            {dashaLoading && <DashaSkeletonRow />}

            {!dashaLoading && dashaData && dashaData.length > 0 &&
                <DashaView
                    timezone={user.userCurrentTimezone} 
                    data={dashaData}
                />
            }

        </Box>
    );
};

export default CharaDasha;
